export default "__VITE_ASSET__C_Ea_aI3__"